import PropTypes from 'prop-types';

export const RESULT__INIT = 'RESULT__INIT';
export const RESULT__FETCH = 'RESULT__FETCH';
export const RESULT__SET_CURRENT_PAGE_ID = 'RESULT__SET_CURRENT_PAGE_ID';

export const RESULT__ITEM_SHAPE = PropTypes.shape({
  state: PropTypes.string,
});
